import Go4EllisText from './Go4EllisText'
export default Go4EllisText